module.exports = __webpack_public_path__ + "7bf5d76eed45ea0a79c31a4913ae80b3.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/fr/google_store.png
// module id = 874
// module chunks = 0